// Meeting zone(0)
// mmp(qa_bts_prod:15037|1003731|4001)
export const ADD_SERVER_ZONE_TYPE_LIMIT: {
  [key: number]: number
} = {
  0: 50,
  15037: 50,
  1003731: 50,
  4001: 50
}
export const ADD_SERVER_DEFAULT_LIMIT = 100

export const CLUSTER_ENV = [
  'Prod',
  'ATS',
  'BTS',
  'QA',
  'DMZ',
  'PSF',
  'FedRamp',
  'INTEGRATION'
]

export const ISSUE_INCIDENT_ENV = [
  {
    label: 'Production',
    value: 'Production'
  },
  {
    label: 'W4G',
    value: 'W4G'
  },
  {
    label: 'FedRamp Meeting',
    value: 'FedRamp Meeting'
  },
  {
    label: 'FedRamp Collab',
    value: 'FedRamp Collab'
  },
  {
    label: 'FedRamp UCMC-G',
    value: 'value="UCMC-G (HCS-G)"'
  },
  {
    label: 'FedRamp UCMC-G Internal',
    value: 'UCMC-G (HCS-G) Internal'
  },
  {
    label: 'FedRamp UCMC-C',
    value: 'UCMC-C'
  },
  {
    label: 'FedRamp AWS',
    value: 'AWS GovCloud'
  }
]
